<div class="reopen-confirmation-modal"
     data-testid="reopen-confirmation-modal"
     role="dialog"
     aria-modal="true"
     [attr.aria-labelledby]="'reopen-confirmation-modal-title'"
     (keydown)="onKeyDown($event)">
  <div class="modal-header" data-testid="modal-header">
    <h2 class="modal-title" 
        data-testid="modal-title"
        [attr.id]="'reopen-confirmation-modal-title'">
      Reopen this item?
    </h2>
  </div>
  
  <div class="modal-content" data-testid="modal-content">
    <p class="confirmation-text" data-testid="confirmation-text">
      Reopening will return the item to Open and reset the trade partner and due date.
    </p>
  </div>
  
  <div class="modal-footer" data-testid="modal-footer" role="group" aria-label="Reopen confirmation actions">
    <button 
      type="button"
      class="btn btn-secondary"
      data-testid="cancel-btn"
      [attr.aria-label]="'Cancel reopening item'"
      (click)="onCancel()">
      Cancel
    </button>
    <button 
      type="button"
      class="btn btn-primary"
      data-testid="reopen-btn"
      [attr.aria-label]="'Reopen this item'"
      (click)="onReopen()">
      Reopen
    </button>
  </div>
</div>
